
import { useState } from "react";
import { Bill } from "../../types";

export function useBillsState() {
  const [bills, setBills] = useState<Bill[]>([]);
  const [loading, setLoading] = useState(true);
  const [fetchComplete, setFetchComplete] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState<string>("all");

  return {
    bills,
    setBills,
    loading,
    setLoading,
    fetchComplete,
    setFetchComplete,
    searchTerm,
    setSearchTerm,
    statusFilter,
    setStatusFilter,
    resetFetchState: () => {
      setFetchComplete(false);
    }
  };
}
